export default __webpack_public_path__ + "static/media/Rishabh.10feb82f.svg";